/** Served from `frontend/public/images/` (root URL `/images/...`). */
export const COMPANY_LOGO_SRC = (process.env.PUBLIC_URL || '') + '/images/company-logo.png';
